import { Attachment } from '@/components/shared/AttachmentDisplay/type';
import { AttachmentCaption } from '@/components/shared/CaptionBox/AttachmentCaption';
import { useAssemblyAttachmentCaption } from '@/hooks/useAssemblyAttachmentCaption';
import { useAttachmentCaption } from '@/hooks/useAttachmentCaptions';
import * as state from '@/components/Analysis/state';
import { useAtomValue } from 'jotai';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import { useEffect } from 'react';
import { CaptionTextFieldLength } from './styles';
import { LocationTag } from '@/constants';

type Props = {
  selectedAttachment: Attachment;
};

const AssemblyAttachmentCaption = ({ selectedAttachment }: Props) => {
  const {
    isEditing,
    setIsEditing,
    attachmentCaption,
    setAttachmentCaption,
    handleCaption,
    captionValidator,
  } = useAttachmentCaption();

  const { updateAssemblyAttachmentCaption } = useAssemblyAttachmentCaption();
  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);
  const { showSnackBar } = useSnackBarMessage({});
  useEffect(() => {
    setAttachmentCaption(selectedAttachment.caption || selectedAttachment.fileName || '');
  }, [selectedAttachment, setAttachmentCaption]);

  const handelAssemblyImageCaption = async () => {
    try {
      setIsEditing(false);
      const isValid = captionValidator(selectedAttachment, selectedAssemblyId);
      if (!isValid || !selectedAssemblyId || !selectedAttachment?.id || !attachmentCaption) {
        if (isValid) {
          showSnackBar('Missing or invalid data for caption update', 'error');
        }
        return;
      }
      await updateAssemblyAttachmentCaption(
        selectedAssemblyId,
        selectedAttachment.id,
        attachmentCaption
      );
      selectedAttachment.caption = attachmentCaption;
      showSnackBar('Caption added successfully', 'success');
    } catch (error) {
      showSnackBar('Failed to update image caption', 'error');
    }
  };
  return (
    <AttachmentCaption
      isEditing={isEditing}
      collectionName="assembly"
      attachmentCaption={attachmentCaption}
      setAttachmentCaption={setAttachmentCaption}
      handleAttachmentCaption={handelAssemblyImageCaption}
      setIsEditing={setIsEditing}
      handleCaption={handleCaption}
      selectedAttachment={selectedAttachment}
      sx={CaptionTextFieldLength}
      location={LocationTag.ReviewPanelComponentOverview}
    />
  );
};

export default AssemblyAttachmentCaption;
